import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { movies } from '@/mocks/movies';

export default function CategoryEntries() {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-5">
      {categories.map((category) => {
        const count = movies.filter((movie) => {
          if (category.key === 'movie') return movie.type === '电影';
          if (category.key === 'tv') return movie.type === '电视剧';
          return movie.type === '综艺';
        }).length;

        return (
          <Link
            key={category.key}
            to={`/category/${category.key}`}
            className="group relative overflow-hidden rounded-lg bg-background-100 border border-background-200 p-5 md:p-6 hover:border-primary-300 transition-colors cursor-pointer"
          >
            <div className="flex items-start justify-between gap-4">
              <div>
                <span className="flex items-center justify-center w-12 h-12 rounded-md bg-primary-500 text-background-50 mb-4 group-hover:bg-accent-500 transition-colors">
                  <i className={`${category.icon} text-2xl`}></i>
                </span>
                <h3 className="font-heading text-lg font-bold text-foreground-950">{category.name}</h3>
                <p className="mt-1 text-xs text-foreground-500 line-clamp-2">{category.intro}</p>
              </div>
              <span className="shrink-0 px-2 py-1 rounded bg-secondary-100 text-secondary-900 text-xs font-medium">
                {count} 部
              </span>
            </div>
            <span className="mt-4 inline-flex items-center gap-1 text-sm text-primary-600 font-medium">
              进入分类
              <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1"></i>
            </span>
          </Link>
        );
      })}
    </div>
  );
}